import { useEffect } from "react";
import { addNativeResumeListener } from "./nativeBrowser";
import { reconcileNativePush } from "./nativePush";
import { isNativeShell } from "./nativeShell";

/* Mount only while signed in: reconciles on mount and every time the app returns to the foreground. */
export const useNativePushRegistration = (): void => {
  useEffect(() => {
    if (!isNativeShell()) return undefined;
    const run = (): void => {
      reconcileNativePush().catch((error: unknown) =>
        console.warn("reconciling native push failed", String(error)),
      );
    };
    run();
    const cleanup = addNativeResumeListener(run);
    return (): void => {
      void cleanup.then((remove) => remove());
    };
  }, []);
};
